import { useTranslation } from "react-i18next";
import { SubTaskPrompt } from "../../interfaces/Task";

export interface SubTaskPromptItemProps {
    prompt: SubTaskPrompt;
    editPrompt: CallableFunction;
    deletePrompt: CallableFunction;
    clonePrompt: CallableFunction;
    position: number;
}

export default function SubTaskPromptItem(props: SubTaskPromptItemProps) {
    const { t } = useTranslation();
    
    const handleEditPrompt = () => {
        props.editPrompt(props.prompt, props.position);
    }

    const handleDeletePrompt = () => {
        if (window.confirm(t("Are you sure you want to delete the prompt? This action cannot be undone."))) {
            props.deletePrompt(props.prompt, props.position);
        }
    }

    const handleClonePrompt = () => {
        props.clonePrompt(props.prompt);
    }

    return(
        <div className="sub-task-prompt-item-container" key={ 'sub-task-prompt-' + props.prompt._id }>
            <div className="name">{ props.prompt.name }</div>
            <div className="actions">
                <a className="clone-link" title={ t("Clone prompt") } onClick={ handleClonePrompt }></a>
                <a className="edit-link" title={ t("Edit prompt") } onClick={ handleEditPrompt }></a>
                <a className="delete-link" title={ t("Delete prompt") } onClick={ handleDeletePrompt }></a>
            </div>
        </div>
    );
}